import { LegalPageLayout } from "./LegalPageLayout";
import { Button } from "@/components/ui/button";

export default function DPO() {
  return (
    <LegalPageLayout title="Délégué à la Protection des Données">
      <h2>Contact du DPO</h2>
      <p>
        Pour toute question concernant vos données personnelles, vous pouvez contacter 
        notre Délégué à la Protection des Données (DPO) :
      </p>

      <div className="not-prose bg-secondary p-6 rounded-lg my-6">
        <p className="font-semibold mb-2">DPO Libaddict</p>
        <p>Email : <a href="mailto:dpo@libaddict.fr" className="text-primary">dpo@libaddict.fr</a></p>
        <p>Adresse : [Adresse postale]</p>
      </div>

      <h2>Demandes que vous pouvez faire</h2>
      <ul>
        <li><strong>Accès à vos données</strong> : Obtenir une copie de toutes vos données</li>
        <li><strong>Rectification</strong> : Corriger des données inexactes</li>
        <li><strong>Effacement</strong> : Supprimer votre compte et vos données</li>
        <li><strong>Portabilité</strong> : Exporter vos données dans un format structuré</li>
        <li><strong>Opposition</strong> : S'opposer à certains traitements</li>
        <li><strong>Limitation</strong> : Limiter l'utilisation de vos données</li>
      </ul>

      <h2>Délais de réponse</h2>
      <p>
        Nous nous engageons à répondre à votre demande dans un délai maximum d'<strong>un mois</strong>.
      </p>

      <h2>Réclamation</h2>
      <p>
        Si vous estimez que vos droits ne sont pas respectés, vous pouvez déposer 
        une réclamation auprès de la CNIL :
      </p>
      <div className="not-prose">
        <Button variant="outline" asChild>
          <a href="https://www.cnil.fr/fr/plaintes" target="_blank" rel="noopener noreferrer">
            Déposer une réclamation à la CNIL
          </a>
        </Button>
      </div>
    </LegalPageLayout>
  );
}
